export {
  getItem,
  isLocalStorageAvailable,
  isSessionStorageAvailable,
  isWebStorageAvailable,
  removeItem,
  setItem,
  webStorageType,
} from './webStorage';

export { throttle } from './throttle';

export { getIgnoreUrls, getUrlFromResource } from './url';



// WEBPACK FOOTER //
// ../../../src/utils/index.ts